import SpecificationInterface from './specification-interface';

class LockedGameSpecification implements SpecificationInterface {
    isSatisfiedBy(params: object): boolean {
        // @ts-ignore
        const {sportConfig, game} = params;

        return (
            sportConfig !== undefined &&
            sportConfig.isModeLateswap() &&
            sportConfig.isGameTypeClassic() &&
            game.isLocked
        );
    }
}

export default new LockedGameSpecification();
